import React, { Component } from 'react';
import './Payment.css';
import moment from 'moment';
import history from '../history';
import { formatBalance } from '../balances';
import { isNftCheck } from '../../nft';
import { network } from '../Network';
import { getOperationTypeTitle } from '../../formats';

class Payment extends Component {
    constructor(props){
        super(props);
        this.state = {
            dest: [],
        }
    }


    componentDidMount() {
        const getDest = async () => {
            const dest = [];
            const source = this.props.payment.source_account;
            if(this.props.payment.ops !== null && this.props.payment.ops !== undefined){
                for (const operation of this.props.payment.ops) {
                    dest.push(await this.formatOperation(operation, source));
                }
            }
            this.setState({
                dest,
            });
        }
        getDest();
    }

    async formatOperation(o, origin){
        var account = '',
            amount = '',
            title = '',
            asset = '',
            sourceAsset = '',
            sourceAmount = '';

        const [assetCode, assetIssuer] = (o.asset && o.asset.split(':')) || [];
        const isNft = await isNftCheck(o.asset_issuer, o.asset_code, network);
        const isNftAsset = await isNftCheck(assetIssuer, assetCode, network);
        const isSourceNft = await isNftCheck(o.source_asset_issuer, o.source_asset_code, network);
        const isSellingNft = await isNftCheck(o.selling_asset_issuer, o.selling_asset_code, network);
        const isBuyingNft = await isNftCheck(o.buying_asset_issuer, o.buying_asset_code, network);
        title = getOperationTypeTitle(o.type);
        switch(o.type_i){
            // Creates a new account in Stellar network.
            case 0:
                amount = formatBalance(o.starting_balance);
                account = o.account;
                asset = 'XDB';
                sourceAsset = '';
                sourceAmount = '';
                break;
            // Sends a simple payment between two accounts in Stellar network.
            case 1:
                amount =  formatBalance(o.amount, isNft);
                if(o.from !== origin){
                    account = o.from;
                }
                if(o.to !== origin){
                    account = o.to;
                }
                asset = (o.asset_type === 'native' ? 'XDB' : o.asset_code);
                sourceAsset = '';
                sourceAmount = '';
                break;
            // Sends a path payment between two accounts in the Stellar network.
            case 2:
                sourceAmount = formatBalance(o.source_amount, isSourceNft);
                sourceAsset =  o.source_asset_type === 'native' ? 'XDB' : o.source_asset_code;
                account = o.to;
                amount = formatBalance(o.amount, isNft);
                asset = o.asset_type === 'native' ? 'XDB' : o.asset_code;
                break;
            case 3:
                sourceAmount = formatBalance(o.amount, isSellingNft);
                sourceAsset =  o.selling_asset_type === 'native' ? 'XDB' : o.selling_asset_code;
                account = o.buying_asset_issuer;
                amount = formatBalance(o.price * o.amount, isBuyingNft);
                asset = o.buying_asset_type === 'native' ? 'XDB' : o.buying_asset_code;
                break;
            // Creates an offer that won’t consume a counter offer that exactly matches this offer.
            case 4:
                sourceAmount = formatBalance(o.amount, isSellingNft);
                sourceAsset = o.selling_asset_type === 'native' ? 'XDB' : o.selling_asset_code;
                account = o.buying_asset_issuer;
                amount = formatBalance(o.price * o.amount, isBuyingNft);
                asset = o.buying_asset_type === 'native' ? 'XDB' : o.buying_asset_code;
                break;
            // Sets account options (inflation destination, adding signers, etc.)
            case 5:
                amount = 0;
                asset = 'XDB';
                break;
            // Creates, updates or deletes a trust line.
            case 6:
                amount = '';
                asset = (o.asset_type === 'native' ? 'XDB' : o.asset_code);
                break;
            // Updates the “authorized” flag of an existing trust line this is called by the issuer of the related asset.
            case 7:
                amount = '';
                asset = (o.asset_type === 'native' ? 'XDB' : o.asset_code);
                break;
            // Deletes account and transfers remaining balance to destination account. 
            case 8:
                if(o.account !== origin){
                    account = o.account;
                }
                if(o.into !== origin){
                    account = o.into;
                }
                break;
            // Runs inflation.
            case 9:
                break;
            // Set, modify or delete a Data Entry (name/value pair) for an account.
            case 10:
                amount = o.source_account;
                break;
            case 11:
                asset = `Bump to ${o.bump_to}`;
                break;
            case 12:
                sourceAmount = formatBalance(o.price * o.amount, isSellingNft);
                sourceAsset = o.selling_asset_type === 'native' ? 'XDB' : o.selling_asset_code;
                account = o.buying_asset_issuer;
                amount = formatBalance(o.amount, isBuyingNft);
                asset = o.buying_asset_type === 'native' ? 'XDB' : o.buying_asset_code;
                break;
            case 13:
                sourceAmount = formatBalance(o.source_amount, isSourceNft);
                sourceAsset =  o.source_asset_type === 'native' ? 'XDB' : o.source_asset_code;
                account = o.to;
                amount = formatBalance(o.amount, isNft);
                asset = o.asset_type === 'native' ? 'XDB' : o.asset_code;
                break;
            case 14:
                account = o.claimants.map(claimant => claimant.destination);
                amount = formatBalance(o.amount, isNftAsset);
                asset = o.asset === 'native' ? 'XDB' : assetCode;
                break;
            case 15:
                account = o.claimant;
                amount = 'Balance id: ';
                asset = o.balance_id;
                break;
            case 16:
                asset = `Sponsored id: ${o.sponsored_id}`;
                break;
            case 17:
                asset = `Begin sponsor: ${o.begin_sponsor}`;
                break;
            case 18:
                amount = `Trustline acc: ${o.trustline_account_id}, `;
                asset = `Asset: ${o.trustline_asset.split(':')[0]}`;
                break;
            case 19:
                sourceAsset = <span>From: <button type="button" className="inject-active" onClick={()=>{history.push('/address/'+o.from)}}>{o.from.substring(0,4)}</button></span>;
                account = o.source_account;
                amount = formatBalance(o.amount, isNft);
                asset = o.asset_code === 'native' ? 'XDB' : o.asset_code;
                break;
            case 20:
                amount = 'Balance id: ';
                asset = o.balance_id;
                break;
            case 21:
                account = o.trustor;
                asset = (o.set_flags_s && `Set flags: ${o.set_flags_s.map(flag => ' ' + flag)}`)
                  || (o.clear_flags_s && `Clear flags: ${o.clear_flags_s.map(flag => ' ' + flag)}`);
                break;
            case 22:
                sourceAmount = `Shares received: ${parseFloat(o.shares_received)};`;
                sourceAsset = `Min price: ${parseFloat(o.min_price)}; Max price: ${parseFloat(o.max_price)}`;
                account = o.source_account;
                amount = `Reserves deposited: ${o.reserves_deposited.map(asset => ` ${parseFloat(asset.amount)}${asset.asset === 'native' ? 'XDB' : asset.asset.split(':')[0]}`)};`;
                asset = `Liquidity pool id: ${o.liquidity_pool_id}`;
                break;
            case 23:
                sourceAmount = `Shares: ${parseFloat(o.shares)}`;
                account = o.source_account;
                amount = `Reserves received: ${o.reserves_received.map(asset => ` ${parseFloat(asset.amount)}${asset.asset === 'native' ? 'XDB' : asset.asset.split(':')[0]}`)};`;
                asset = `Liquidity pool id: ${o.liquidity_pool_id}`;
                break;
            default:
                title = 'Unknown operation';
        }
        return {
            account: account,
            amount: amount,
            title: title,
            asset: asset,
            sourceAsset: sourceAsset,
            sourceAmount: sourceAmount,
        };
    }

    render() {
        const source = this.props.payment.source_account;

        return (
            <div className="payment">
                <div className="payment-header">
                    {history && history.getCurrentLocation().pathname.includes('/transaction/')
                      ? <div className="payment-hash-value">{this.props.payment.id}</div>
                      : <button type="button" className="payment-hash-value-button" onClick={()=> history.push('/transaction/' + this.props.payment.id)}>{this.props.payment.id}</button>}
                    <p className="payment-time">{moment(this.props.payment.created_at).format('YYYY-MM-DD HH:mm:ss')}</p>
                </div>
                <div className="payment-hash">
                    <button type="button" className="payment-hash-value-button" onClick={()=>{history.push('/address/'+source)}}>{source}</button>
                    <p className="payment-hash-time">{moment(this.props.payment.created_at).fromNow()}</p>
                </div>
                {this.state.dest.map((d, i)=>{
                    var set = [];
                    set.push(<div className="payment-details-from" key={"amount"+i}>
                        <p className="payment-details-from-title">{d.title}</p>
                        <p className="payment-details-from-amount">{d.sourceAmount} {d.sourceAsset}</p>
                    </div>);
                    set.push(<div className="payment-details-sign" key={"sign"+i}>
                    </div>);
                    set.push(<div className="payment-details-to" key={"payment"+i}>
                        <div className="payment-details-to-col">
                            {Array.isArray(d.account)
                              ? d.account.map((account, index) => (
                                <button
                                  key={account}
                                  type="button"
                                  className="payment-details-to-to"
                                  onClick={()=>{history.push('/address/'+account)}}
                                >
                                    {`${d.account.length === index + 1 ? account : account + ', '}`}
                                </button>
                              ))
                              : <button type="button" className="payment-details-to-to" onClick={()=>{history.push('/address/'+d.account)}}>{d.account}</button>
                            }
                            <p className="payment-details-to-amount">{d.amount} {d.asset}</p>
                        </div>
                    </div>);
                    return (<div className="payment-details" key={"details"+i}>{set}</div>);
                })}
            </div>
        );
    }
}

export default Payment;



// WEBPACK FOOTER //
// ./src/components/Payment/Payment.js